import React from 'react';
import LocationTemplate from './LocationTemplate';

const HickoryPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Hickory"
      stateName="North Carolina"
      countyName="Catawba"
      zipCodes={["28601", "28602", "28603"]}
      latitude={35.7344}
      longitude={-81.3412}
      population={43569}
      historicalFact="Known for furniture manufacturing and as the 'City of Furniture,' located in the foothills of the Blue Ridge Mountains."
      nearbyTowns={[
        "Newton, NC",
        "Conover, NC",
        "Lenoir, NC",
        "Morganton, NC",
        "Statesville, NC",
        "Maiden, NC",
        "Granite Falls, NC",
        "Claremont, NC"
      ]}
    />
  );
};

export default HickoryPage;